import apiClient from "./ApiClient";

export function fetchImageSliders() {
  return apiClient.get("/image-sliders").then((res) => res.data);
}

export function createImageSlider(dto) {
  console.log("Creating image slider with data:", dto);
  return apiClient.post("/image-sliders", dto).then((res) => res.data);
}

export function updateImageSlider(id, dto) {
  return apiClient.put(`/image-sliders/${id}`, dto).then((res) => res.data);
}

export function deleteImageSlider(id) {
  return apiClient.delete(`/image-sliders/${id}`);
}
